import { IStatMap } from "../contracts/StatMap";
import { ISwtchTransactionRequest, SwtchTransaction } from "../contracts/Swtch";
import { IZeosApiResponse } from "../contracts/ZeosApi";
import { getDataAsync, postDataAsync } from "../ZeosApiExecutor";
import { ISwtch } from "./interfaces/ISwtch";

const API_BASE_URL = `/SwitchApi`;

export const Swtch: ISwtch = {
  getTransactions: async (
    req: ISwtchTransactionRequest
  ): Promise<IZeosApiResponse<SwtchTransaction>> => {
    return await postDataAsync<SwtchTransaction>(
      `${API_BASE_URL}/transactions`,
      req
    );
  },
  getEVStats: async (
    propertyId: number
  ): Promise<IZeosApiResponse<IStatMap>> => {
    return await getDataAsync<IStatMap>(
      `/SwitchApi/EvMetrics/${propertyId}`,
      "data"
    );
  },
};
